module.exports = __webpack_public_path__ + "img/france.53e1a161.svg";